const ExpirationDateSelect: React.FC<{
  selectedExpiration: string;
  setSelectedExpiration: (value: string) => void;
}> = ({ selectedExpiration, setSelectedExpiration }) => {
  const expirationOptions = [
    { value: "1hour", label: "1 hour" },
    { value: "1day", label: "1 day" },
    { value: "1week", label: "1 week" },
    { value: "1month", label: "1 month" },
    { value: "never", label: "Never expired" },
  ];

  return (
    <div className="relative">
      <select
        className="w-full pl-3 pr-8 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm appearance-none bg-white"
        value={selectedExpiration}
        onChange={(e) => setSelectedExpiration(e.target.value)}
      >
        {expirationOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <svg
          className="w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </div>
  );
};

export default ExpirationDateSelect;
